import { Task } from "../../types/farming";
import { ListEntrySquished } from "../Common/Elements/ListEntry";
import {
    arrow,
    check,
    circle,
    discordIcon,
    inviteIcon,
    telegramIcon,
    tonTaskIcon,
    zealyIcon,
    yepIcon,
    xIcon,
    starIcon,
    appTaskIcon
} from "../Common/Icons/Icons";
import { useContext, useEffect } from "react";
import { useUtils, useInitData } from "@tma.js/sdk-react";
import { ReloadTasksContext } from "./TasksView";
import { getBehaviour } from "./TaskClaimBehaviour";
import { patchTask } from "../../communication/communication";
import { formatBalanceNumber } from "../../communication/format";
import { useTranslation } from "react-i18next";

function findIconByTask(task: Task) {
    switch (task.icon_type) {
        case "Friend": return inviteIcon;
        case "Telegram": return telegramIcon;
        case "X": return xIcon;
        case "TON": return tonTaskIcon;
        case "Discord": return discordIcon;
        case "Zealy": return zealyIcon;
        case "YEP": return yepIcon;
        case "Star": return starIcon;
        case "App": return appTaskIcon;
    }
    return (<img className="square-image" crossOrigin="" src={task.icon_url} alt="pic" />)
}

export function TaskEntry({ task }: { task: Task }) {
    const reloadTasks = useContext(ReloadTasksContext)
    const utils = useUtils()
    const initData = useInitData()
    const { i18n } = useTranslation()

    useEffect(() => {
        if (task.status === "Inprogress") {
            const time = task.finish_ts - new Date().getTime();
            setTimeout(reloadTasks, time < 0 ? 0 : time);
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const tryOpenLink = (link: string | undefined) => {
        if (link === undefined) return;
        if (link.startsWith("https://t.me/") || link.startsWith("t.me/"))
            utils.openTelegramLink(link);
        else
            utils.openLink(link);
    }

    const redirectMarkRefresh = () => {
        if (task.status !== "Open") {
            tryOpenLink(task.target_link);
            return;
        }

        if (task.target_link === undefined) {
            const behaviour = getBehaviour(initData!, utils, task.code)
            behaviour()
        }

        if (task.type === "Delayed") {
            const patched = {
                status: "Inprogress",
                finish_ts: new Date().getTime() + 1000 * 5
            }
            patchTask(task.task_id, JSON.stringify(patched))
                .then(_ => reloadTasks())

            setTimeout(reloadTasks, patched.finish_ts - new Date().getTime() + 1000)
        }

        tryOpenLink(task.target_link);
    }

    const gray = "var(--font-dim)"
    const explytColor = "var(--color-main)"

    // Case for open and default values
    let entryCssClass = "list-entry-bg clickable"
    let entryStatusIcon = arrow

    if (task.status === "Claimed") {
        entryCssClass = "list-entry-bg-outline";
        entryStatusIcon = check(gray)
    } else if (task.status === "Done") {
        entryCssClass = "list-entry-bg clickable";
        entryStatusIcon = check(explytColor)
    } else if (task.status === "Inprogress") {
        entryCssClass = "list-entry-bg clickable";
        entryStatusIcon = circle
    }

    const picture = <div className="square-image">{findIconByTask(task)}</div>

    let taskName = task.localized_names?.[i18n.language] ?? task.name;

    const entry = <ListEntrySquished
        imageElement={<div className="flex-center">{picture}</div>}
        title={<span className="task-entry-name micro-margin-all"> {taskName} </span>}
        subscript={<span className={`micro-margin-all bonus-gray`}> {`+${formatBalanceNumber(task.bonus)} Test Credits`} </span>}
        rightText={<span className="friend-balance">{entryStatusIcon}</span>}
    />

    return <div className={`small-margin ${entryCssClass}`} onClick={redirectMarkRefresh}>
        {entry}
    </div>
}